import React from 'react';

function ListSection({ items, ordered = false, className }) {
	if (!Array.isArray(items) || items.length === 0) return null;
	const Tag = ordered ? 'ol' : 'ul';
	return (
		<Tag className={className}>
			{items.map((item) => <li key={item}>{item}</li>)}
		</Tag>
	);
}

function JourneyEmergencyPanel({ altitudeSickness, helicopterEvacuation, emergencyContacts, porterGuide, licensedAgencies }) {
	const hasContent = altitudeSickness || helicopterEvacuation
		|| (Array.isArray(emergencyContacts) && emergencyContacts.length > 0)
		|| porterGuide || licensedAgencies;

	return (
		<div className="guided-panel">
			<h3 className="guided-panel__title">Safety & emergency</h3>
			<p className="guided-panel__intro">Read this before you need it. HRA golden rules save lives.</p>

			{!hasContent && (
				<p className="guided-panel__intro">Emergency reference for this trek is being expanded. Tourist Police: <strong>1144</strong> (toll-free, English, 24/7).</p>
			)}

			{altitudeSickness && (
				<section className="guided-emergency__section">
					<h4>Altitude sickness (HRA)</h4>
					<ListSection items={altitudeSickness.goldenRules} ordered className="guided-emergency__rules" />
					{altitudeSickness.symptoms && (
						<>
							<p><strong>Mild AMS:</strong> {altitudeSickness.symptoms.mild}</p>
							<p><strong>Severe (evacuate):</strong> {altitudeSickness.symptoms.severe}</p>
						</>
					)}
					<ListSection items={altitudeSickness.prevention} />
					{Array.isArray(altitudeSickness.aidPosts) && altitudeSickness.aidPosts.length > 0 && (
						<>
							<h5>Medical posts on trail</h5>
							<ul>
								{altitudeSickness.aidPosts.map((p) => (
									<li key={p.name}>
										<strong>{p.name}</strong> ({p.altitude}) — {p.services}
										{p.url && <> <a href={p.url} target="_blank" rel="noopener noreferrer">HRA →</a></>}
									</li>
								))}
							</ul>
						</>
					)}
				</section>
			)}

			{helicopterEvacuation && (
				<section className="guided-emergency__section">
					<h4>Helicopter evacuation</h4>
					{helicopterEvacuation.costWithoutInsurance && (
						<p>Cost without insurance: <strong>{helicopterEvacuation.costWithoutInsurance}</strong></p>
					)}
					<ListSection items={helicopterEvacuation.procedure} ordered />
					{helicopterEvacuation.insuranceTip && <p><small>{helicopterEvacuation.insuranceTip}</small></p>}
				</section>
			)}

			{Array.isArray(emergencyContacts) && emergencyContacts.length > 0 && (
				<section className="guided-emergency__section">
					<h4>Emergency numbers</h4>
					<table className="guided-emergency__table">
						<tbody>
							{emergencyContacts.map((c) => (
								<tr key={c.label}>
									<td><strong>{c.label}</strong></td>
									<td>{c.number}</td>
									<td>{c.note}</td>
								</tr>
							))}
						</tbody>
					</table>
				</section>
			)}

			{porterGuide && (
				<section className="guided-emergency__section">
					<h4>Porter hiring guide</h4>
					{porterGuide.hiring && <p>{porterGuide.hiring}</p>}
					{(porterGuide.costPerDay || porterGuide.weightLimit) && (
						<p>
							{porterGuide.costPerDay && <><strong>Cost:</strong> {porterGuide.costPerDay}</>}
							{porterGuide.costPerDay && porterGuide.weightLimit && ' · '}
							{porterGuide.weightLimit && <><strong>Weight:</strong> {porterGuide.weightLimit}</>}
						</p>
					)}
					{porterGuide.tipping && <p><strong>Tipping:</strong> {porterGuide.tipping}</p>}
					<ListSection items={porterGuide.etiquette} />
				</section>
			)}

			{licensedAgencies && (
				<section className="guided-emergency__section">
					<h4>Licensed agencies (verify TAAN)</h4>
					{licensedAgencies.verifyUrl && (
						<p>
							<a href={licensedAgencies.verifyUrl} target="_blank" rel="noopener noreferrer">
								{licensedAgencies.verifyLabel || 'TAAN'} →
							</a>
						</p>
					)}
					<ListSection items={licensedAgencies.howToVerify} />
					{licensedAgencies.examplesNote && <p><small>{licensedAgencies.examplesNote}</small></p>}
					{Array.isArray(licensedAgencies.agencies) && licensedAgencies.agencies.length > 0 && (
						<ul>
							{licensedAgencies.agencies.map((a) => (
								<li key={a.name}>
									<strong>{a.name}</strong>
									{a.specialty && <> — {a.specialty}</>}
									{a.mapsUrl && (
										<> <a href={a.mapsUrl} target="_blank" rel="noopener noreferrer">Map →</a></>
									)}
								</li>
							))}
						</ul>
					)}
				</section>
			)}
		</div>
	);
}

export default JourneyEmergencyPanel;
